<template v-cloack>
	<div>
		<h1>{{$t('Chapters')}}</h1>

		<div class="mt-5 mb-3">
			<div>
				<hotelDropdown v-show="user.role != 4" v-bind:append_to_body="false" v-bind:current_stay="''" v-on:onChangeHotel="onChangeHotel"></hotelDropdown>
			</div>

			<div v-if="user.role == 4">
                <h3>{{ user.staff_info.hvg_desc }}</h3>
            </div>
		</div>

		<div>
			<vs-button v-if="!show_menus" class="float-right" color="primary" type="filled" v-on:click="hideChapters()">{{$t('returnButton')}}</vs-button>
		</div>

		<vx-card v-if="hotel_id != '' && menus.length == 0" class="mt-5">
			<div>
				<p align="center">{{$t('Não_foram_encontradas_cartas_para_o_hotel_selecionado')}}</p>
			</div>
		</vx-card>

		<div v-if="show_menus">
			<div v-if="menus.length > 0" class="mt-5">
				
				<vs-divider color="primary" position="left">{{$t('Carta')}}</vs-divider>

				<vs-list v-for="(menu, key) in menus" :key="key" v-if="menu.type == 'Carta'">
					<vs-table :data="menu.idiomas">
						<vs-tr>
							<vs-td class="w-2/5">
								{{ menu.idiomas[0].name }}
							</vs-td>

							<vs-td class="w-2/5">
								<vs-button v-for="(item, index) in menu.idiomas" :key="index" color="success" type="line" line-origin="left" v-on:click="addChapter(item, menu.type)"><strong>{{ item.language }}</strong></vs-button>
							</vs-td>
						</vs-tr>
					</vs-table>
				</vs-list>

				<vs-divider color="primary" position="left">{{$t('Menu')}}</vs-divider>

				<vs-list v-for="(menu, key) in menus" :key="key" v-if="menu.type == 'Menu'">
					<vs-table :data="menu.idiomas">
						<vs-tr>
							<vs-td class="w-2/5">
								{{ menu.idiomas[0].name }}
							</vs-td>

							<vs-td class="w-2/5">
								<vs-button v-for="(item, index) in menu.idiomas" :key="index" color="success" type="line" line-origin="left" v-on:click="addChapter(item, menu.type)"><strong>{{ item.language }}</strong></vs-button>
							</vs-td>
						</vs-tr>
					</vs-table>
				</vs-list>
			</div>
		</div>

		<div class="w-full mt-5" v-if="!show_menus">
			<h3 class="mb-5">{{ selected_menu.name }} » {{ selected_menu.language }}</h3>

			<vx-card class="w-full mt-5">
				<div class="flex flex-wrap">
					<div class="sm:w-full lg:w-1/2">
						<h3 class="w-full">{{ updateMode ? 'Editar' : 'Novo' }}</h3>

						<vs-divider />

						<div class="flex flex-wrap mt-3 pr-3">
							<div class="sm:w-full lg:w-2/3">
								<vs-input v-model="chapter" class="w-full" :label="$t('nome')"/>
							</div>

							<div class="sm:w-full lg:w-1/3 lg:pl-3 pl-0">
								<vs-input v-model="order_by" type="number" min="0" class="w-full" :label="$t('Ordem_n')"/>
							</div>

							<div class="sm:w-full lg:w-1/5 pr-5" v-if="updateMode == false">
								<vs-button class="mt-6" color="success" type="border" v-on:click="addChapterToList()">{{$t('Adicionar')}}</vs-button>
							</div>
						</div>

						<div class="sm:w-full lg:w-2/3 mt-5" v-if="updateMode == false">
							<vs-list>
								<draggable :list="new_chapters_sorted" class="cursor-move">
									<vs-list-item v-for="(chapter, index) in new_chapters_sorted" :key="index" :title="(chapter.order_by == 0) ? chapter.name : chapter.order_by+ 'º ' +chapter.name">
										<div class="flex flex-wrap">
											<vs-button type="filled" color="danger" size="small" v-on:click="removeChapter(index)" icon-pack="feather" icon="icon-x"></vs-button>
										</div>
									</vs-list-item>
								</draggable>
							</vs-list>
						</div>

						<div class="w-full">
							<div class="flex flex-wrap my-5 -mx-1">
									<div class="sm:w-full md:w-1/2 lg:w-1/3 mb-2 mx-1">
										<vs-button class="w-full" color="success" type="filled" v-on:click="saveChapter()">{{$t('Gravar')}}</vs-button>
									</div>
									<div class="sm:w-full md:w-1/2 lg:w-1/3 mx-1">
										<vs-button class="w-full" v-if="updateMode" color="danger" type="filled" v-on:click="exit_edit_mode()">{{$t('cancels')}}</vs-button>
									</div>
							</div>
						</div>
					</div>

					<div class="w-full lg:w-1/2">
						<h3>{{$t('Chapters')}}</h3>
						<vs-divider/>
						<vs-list>
							<p align="center" v-if="chapters.length == 0">
								{{$t('Não_foram_encontrados_capítulos')}}
							</p>
							<vs-list-item :key="indextr" v-for="(item, indextr) in convertToBool(chapters)" :title="(item.order_by == 0) ? item.name : item.order_by+ 'º ' +item.name">
								<vs-button color="primary" type="flat" icon-pack="feather" icon="icon-edit" v-on:click="enter_edit_mode(item)" class="inline-block"></vs-button>
								<vs-button type="filled" color="danger" size="small" v-on:click="deleteChapter(item.id)" icon-pack="feather" icon="icon-x" class="inline-block ml-2"></vs-button>
							</vs-list-item>				
						</vs-list>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
</template>

<script>
import HotelDropdown from '@/views/components/HotelDropdown.vue';
import draggable from 'vuedraggable';

export default {
	data() {
		return {
			hotel_id: '',
			type: '',
			currency: '',
			selected_menu: '',
			show_menus: true,
			response: null,
			menus: [],
			nome: '',
			order_by: '0',
			chapter: '',
			new_chapters: [],
			chapters: [],
			user: '',
			updateMode: false,
			chaper_id: '',
			visibility: ''
		}
	},

    methods: {
        onChangeHotel(hotel_id) {
			this.hotel_id = hotel_id;
			this.show_menus = true;
			this.clearChapter();
			this.getMenusWihtLanguages(hotel_id);
			setTimeout(() => {
				this.menus = this.menus.filter(x => x.type != 'Directório');
			}, 1000);
		},
		
		addChapter(menu, type) {
			this.selected_menu = menu;
			this.type = type;
			this.show_menus = false;
			this.getChapters(this.selected_menu)
		},

		addChapterToList(lang) {

            if (this.chapter == '' || this.order_by == '' || isNaN(this.order_by) || parseInt(this.order_by) < 0) {
            	this.$vs.notify({
					time: 4000,
					text: this.$t('O_campo_Ordem_deve_ser_númerico_e_maior_ou_igual_a'),
					color:'danger',
					position:'bottom-right',
					iconPack: 'feather',
					icon:'icon-alert-triangle'
				});

				this.$vs.notify({
					time: 4000,
					text: this.$t('O_campo_Nome_é_obrigatório'),
					color:'danger',
					position:'bottom-right',
					iconPack: 'feather',
					icon:'icon-alert-triangle'
				});

            } else {
                this.new_chapters.push({name: this.chapter, visibility: 1, order_by: this.order_by});
				this.chapter = '';
				this.order_by = '0';
			}
        },
		
		clearChapter() {			
			this.new_chapters = [];
			this.chapters = [];
		},

		hideChapters() {
			this.selected_menu = [];
			this.type = '';
			this.show_menus = true;
			this.new_chapters = '';
			this.clearChapter();
			this.exit_edit_mode();
		},

		removeChapter(index) {
            this.new_chapters.splice(index, 1);
		},

		deleteChapter: function(id) {
			this.$vs.loading();
			let that = this;
			this.$api({
				method: 'post',
				url: '/myvilagale/hotel/chapters/delete',
				params: {
					token: this.user.usertoken,
					id: id
				},
			})
			.then(function (res) {
				that.chapters = that.chapters.filter(item => item.id !== id);
				that.$vs.loading.close();
				that.$vs.notify({
					text: res.data.message,
					color:'success',
					position:'bottom-right',
					iconPack: 'feather',
					icon:'icon-check'
				});
			}) 
			.catch( function (err) {
				that.$vs.notify({
					text: that.$t('Ocorreu_um_erro_ao_eliminar_o_registo.'),
					color:'danger',
					position:'bottom-right',
					iconPack: 'feather',
					icon:'icon-alert-triangle'
				});
				that.$vs.loading.close();
			});
		},
		
		enter_edit_mode(chapter) {
			this.updateMode = true;
			this.chapter = chapter.name;
			this.order_by = chapter.order_by;
			this.chaper_id = chapter.id;
			this.visibility = chapter.visibility;
		},

		exit_edit_mode() {
			this.updateMode = false;
			this.chapter = '';
			this.chaper_id = '';
			this.order_by = '0';
		},
		
		saveChapter() {
			if(this.new_chapters.length == 0 && !this.updateMode) {
				this.$vs.notify({
					time: 4000,
					text: this.$t('Este_menu_já_foi_registado.'),
					color:'danger',
					position:'bottom-right',
					iconPack: 'feather',
					icon:'icon-alert-triangle'
				});

				return false;
			}

			if(this.updateMode && this.chapter.length == 0) {
				this.$vs.notify({
					time: 4000,
					text: this.$t('O_campo_Nome_é_obrigatório'),
					color:'danger',
					position:'bottom-right',
					iconPack: 'feather',
					icon:'icon-alert-triangle'
				});

				return false;
			}

			if(this.updateMode && (this.order_by == '' || isNaN(this.order_by) || parseInt(this.order_by) < 0)) {
				this.$vs.notify({
					time: 4000,
					text: this.$t('O_campo_Ordem_deve_ser_númerico_e_maior_ou_igual_a'),
					color:'danger',
					position:'bottom-right',
					iconPack: 'feather',
					icon:'icon-alert-triangle'
				});

				return false;
			}

			this.$vs.loading();

			let params = { 
				menu_idioma_id: this.selected_menu.id,
			};

			if(!this.updateMode) {
				params.chapters = this.new_chapters;
			}
			else {
				params.chapters = [
					{
						id: this.chaper_id,
						name: this.chapter, 
						order_by: parseInt(this.order_by),
						visibility: this.visibility
					}
				];
			}

			let that = this;

			let createUrl = '/myvilagale/hotel/' + this.hotel_id + '/menu/' + this.selected_menu.id + '/chapters?token=' + localStorage.getItem('usertoken');

			let updateUrl = '/myvilagale/hotel/chapter/update?token=' + localStorage.getItem('usertoken')

			this.$api.post( this.updateMode ? updateUrl : createUrl,
				params,
				{
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'Bearer ' + localStorage.getItem('usertoken')
					}
				})
				
				.then(function(res) {
					that.getChapters(that.selected_menu);
					that.clearChapter();

                    that.$vs.loading.close();
                    that.$vs.notify({
						time: 4000,
						text: that.updateMode ? that.$t('Registo_alterado_com_sucesso') : that.$t('Registo_criado_com_sucesso'),
                        color:'success',
                        position:'bottom-right',
                        iconPack: 'feather',
                        icon:'icon-check'
					});
					
					that.exit_edit_mode();
                })
                .catch(function() {
                    that.$vs.loading.close();
                    that.$vs.notify({
						time: 4000,
						text: that.updateMode ? that.$t('Ocorreu_um_erro_ao_alterar_o_registo') : that.$t('Ocorreu_um_erro_ao_criar_o_registo'),
                        color:'danger',
                        position:'bottom-right',
                        iconPack: 'feather',
                        icon:'icon-alert-triangle'
                    });
                });
		},
	},
	computed: {
		new_chapters_sorted: function() {
			let c_tmp_zeros = this.new_chapters.filter((item, idx) => item.order_by == 0);
			let c_tmp_no_zeros = this.new_chapters.filter((item, idx) => item.order_by != 0);
			c_tmp_no_zeros = c_tmp_no_zeros.sort((a, b) => a.order_by - b.order_by);
			return c_tmp_no_zeros.concat(c_tmp_zeros);
		},
	},
	created() {
		this.user = JSON.parse(window.localStorage.getItem('userSession'));

		if (this.user.role == 4) {
			this.hotel_id = this.user.staff_info.hvg_id;
			this.getMenusWihtLanguages(this.hotel_id);
			this.menus = this.menus.filter(x => x.type != 'Directório');
		}
	},
    components: {
		HotelDropdown,
		draggable,
    }
}
</script>

<style scoped>

	.main_element_title {
		margin-top: 25px;
	}

	.hotel_dropdown {
		margin-top: 25px;
		display: flex;
	}

	.type_dropdown {
		margin-top: 25px;
		display: flex;
	}

	.dropdown_label {
		color: #4A4E4F;
		margin-top: 9px;
		margin-right: 15px;
	}

	.dropdown_label_description {
		margin-top: 25px;
	}

	.information_block {
		display: flex;
	}

	.dropdown_label_information {
		margin-top: 25px;
	}

	.dropdown_label_name {
		margin-top: 25px;
	}

	.price_block {
		display: flex;
	}

	.label_price {
		margin-top: 25px;
	}

	.moeda_dropdown {
		margin-top: 25px;
		display: flex;
	}

	.main_element_title {
		color: #4A4E4F;
	}

	.visibility_block {
		margin-top: 25px;
	}

	.visibility li {
		width: 16.66%;
		text-align: center;
		color: #63C0BB;
		display: inline-block;
	}

</style>